import { MatchSocketRepository } from "../repositories/SocketRepository";

export class EmitLike {
	constructor(private repository: MatchSocketRepository) {}
	execute(params: EmitLikeParams): Promise<void> {
		return this.repository.emitLike(params.userId, params.type);
	}
}

export class EmitLikeParams {
	constructor(public userId: string, public type: string) {}
}
